
import React from "react"
import { Synonyms } from "./Synonyms"
import "../Styles/Meaning.css"
export function Meanings(props) {
    return (
        <>
            <h3>{props.meaning.partOfSpeech}</h3>

            {props.meaning.definitions.map(
                function (definition, index) {
                    return (
                        <div key={index}>
                            <div className="definition"> {definition.definition}

                            </div>
                            <div className="example">
                                <em > {definition.example}</em>
                            </div>
                            {<Synonyms synonyms={definition.synonyms} />}
                        </div>


                    )
                })}
        </>
    )
}